// extracted by mini-css-extract-plugin
export var overviewLabel = "index-module--overviewLabel--Wc0yD";
export var container = "index-module--container--1Elhx";